import { render, staticRenderFns } from "./bookmark.vue?vue&type=template&id=5824d534&scoped=true&lang=pug&"
import script from "./bookmark.ts?vue&type=script&lang=ts&"
export * from "./bookmark.ts?vue&type=script&lang=ts&"
import style0 from "./bookmark.vue?vue&type=style&index=0&id=5824d534&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5824d534",
  null
  
)

export default component.exports